import * as React from 'react';
import { useFullHeight } from "../helpers/useFullHeight";

export default function AppFullHeight(): JSX.Element {
  useFullHeight();

  return null;
}
